import { exp } from "./export";
import { utils } from '../utils.js';
import { lang } from '../lang.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';

exp.getNewBead = myBead => {
    let mySwatch = {
        ...b3.store.state.swatches.find(element => element.id === myBead.style)
    };
    if (mySwatch === undefined) {
        mySwatch = {
            letterCode: '',
            fillColor: 0xf0f0f0
        };
    }
    if (myBead.ignore) mySwatch.fillColor = 0xffffff;
    let myColor = utils.colorToHex(mySwatch.fillColor);
    // return a copy of the bead with the info we will need
    return {
        letterCode: mySwatch.letterCode,
        fillColor: mySwatch.fillColor,
        whiteOrBlack: utils.isHexLight(myColor) ? '#000' : '#FFF',
        ignore: myBead.ignore
    };
};

exp.getBead = (startingBead, direction, i, j) => {
    let readfn;

    if (startingBead === 'topLeft') {
        readfn = (i, j) => beads.findBead(i, j);
    } else if (startingBead === 'topRight') {
        readfn = (i, j) => beads.findBead(settings.columns - i - 1, j);
    } else if (startingBead === 'bottomLeft') {
        readfn = (i, j) => beads.findBead(i, settings.rows - j - 1);
    } else if (startingBead === 'bottomRight') {
        readfn = (i, j) => beads.findBead(settings.columns - i - 1, settings.rows - j - 1);
    }

    return (direction === 'horizontal') ? readfn(j, i) : readfn(i, j);
};

exp.getStrips = ({options}) => {

    if (settings.pattern.getStripsKey) {
        return exp[settings.pattern.getStripsKey]();
    }

    let result = [];
    const direction = exp.determineDirection({
        beadingDirection: options.beadingDirection,
        pattern: settings.pattern
    });
    let startingBead = options.startingBead;
    let maxStripWidth = settings.pattern.canSelectPanelWidth ? options.exportStripWidth : 800;

    if (!options.usePanels) maxStripWidth = 800; // don't use strips if 'use strips' not checked

    exp.offsetPattern = exp.getOffsetPattern({options});

    // transform the project so that we're always reading the same way (starting top left, horizontal -> )
    // transform starting bead for peyote
    if (settings.pattern.rotateCamera) {
        if (startingBead === 'topLeft') startingBead = 'bottomLeft';
        else if (startingBead === 'topRight') startingBead = 'topLeft';
        else if (startingBead === 'bottomLeft') startingBead = 'bottomRight';
        else if (startingBead === 'bottomRight') startingBead = 'topRight';
    }

    let myRows = (direction === 'horizontal') ? settings.rows : settings.columns;
    let myColumns = (direction === 'horizontal') ? settings.columns : settings.rows;

    let myArr = []; // will contain transformed project

    for (let i = 0; i < myRows; i++) {
        let r = [];

        for (let j = 0; j < myColumns; j++) {
            let myBead = exp.getBead(startingBead, direction, i, j);
            let newBead = exp.getNewBead(myBead);
            r.push(newBead);
        }

        myArr.push(r);
    }

    // work out width of each strip

    let stripWidths = exp.getStripWidths(myColumns, maxStripWidth);

    // populate each strip

    let myColumnMarker = 0;
    let stripNumber = 1;

    stripWidths.forEach(stripWidth => {
        let currentStrip = {
            stripNumber: stripNumber,
            startColumn: myColumnMarker,
            endColumn: myColumnMarker + stripWidth,
            width: stripWidth,
            rows: [] // contains the bead data!
        };
        myArr.forEach(row => {
            currentStrip.rows.push(row.slice(myColumnMarker, myColumnMarker + stripWidth)); // add beads to strip
        });
        myColumnMarker += stripWidth;
        stripNumber++;
        result.push(currentStrip);
    });

    return result;
};

exp.shouldCombineRows = () => {
    if (settings.pattern.name.slice(0, 5) === 'brick') {
        for (let i = 0; i < beads.rowOffset.length - 1; i++) {
            if (beads.rowOffset[i] == beads.rowOffset[i + 1]) {
                return true;
            }
        }
    }
    return false;
};

exp.getStripWidths = (width, maxWidth) => {
    // strips are split over multiple tables if width > maxwidth

    let neededStrips = Math.floor((width - 1) / maxWidth) + 1; // how many strips will we need
    let myDivide = Math.floor(width / neededStrips); // how long each strip is not including the remainder
    let myRemainder = width % neededStrips; // how many strips need + 1 column to sum up correctly
    let stripWidths = [];
    for (let i = 0; i < neededStrips; i++) {
        let l = myDivide;
        if (myRemainder > 0) {
            l++;
            myRemainder--;
        }
        stripWidths.push(l);
    }

    return stripWidths;
};

exp.determineDirection = ({beadingDirection, pattern}) => {
    if (pattern.name.slice(0, 5) === 'brick') return 'horizontal'; // brick stitch must be horizontal
    if (settings.pattern.rotateCamera) return 'vertical'; // peyote must be vertical

    return beadingDirection;
};

exp.getOffsetPattern = ({options}) => {
    let result = [];
    let startingBead = options.startingBead;

    // transform starting bead for peyote
    if (settings.pattern.rotateCamera) {
        if (startingBead == 'topLeft') startingBead = 'bottomLeft';
        else if (startingBead == 'topRight') startingBead = 'topLeft';
        else if (startingBead == 'bottomLeft') startingBead = 'bottomRight';
        else if (startingBead == 'bottomRight') startingBead = 'topRight';
    }

    if (startingBead == 'topLeft') {
        beads.rowOffset.forEach(i => {
            result.push(i);
        });
    } else if (startingBead == 'topRight') {
        beads.rowOffset.forEach(i => {
            let num = (i == 0) ? 1 : 0;
            result.push(num);
        });
    } else if (startingBead == 'bottomLeft') {
        for (let i = settings.rows - 1; i >= 0; i--) {
            result.push(beads.rowOffset[i]);
        }
    } else if (startingBead == 'bottomRight') {
        for (let i = settings.rows - 1; i >= 0; i--) {
            let num = (beads.rowOffset[i] == 0) ? 1 : 0;
            result.push(num);
        }
    }

    return result;
};

exp.parseRow = (row, reverse=false) => {

    let result = [];
    let myLetters = [];

    // reverse row if necessary

    let j = 0;
    for (let i = 0; i < row.length; i++) {
        j = reverse ? (row.length - 1) - i : i;
        myLetters.push(row[j].letterCode);
    }

    let addEntry = (spacing=null) => {
        let myText = (currentLetter) ? currentLetter : '*';
        result.push(myCount.toString());
        let obj = {
            text: myText,
            bold: true,
        };
        if (!currentLetter) {
            obj.color = 'grey';
            exp.hasBlanks = true;
        }
        result.push(obj);
        if (spacing) result.push(spacing);
    };

    let currentLetter = myLetters[0];
    let myCount = 1;

    for (let i = 1; i < myLetters.length; i++) {
        if (currentLetter == myLetters[i]) {
            myCount++;
        } else {
            addEntry(', ');
            currentLetter = myLetters[i];
            myCount = 1;
        }
    }

    addEntry();

    return result;
};


exp.cycleRow = ({row, index, options}) => { // for tubular peyote

    const myArr = exp.getOffsetPattern({options});

    if (index == 0) return row; // no cycle on first (combined) row

    const nextCol = col => {
        const startingValue = myArr[col];
        for (let i = col + 1; i < myArr.length; i++) {
            if (myArr[i] !== startingValue) {
                return i;
            }
        }
        return 0; // cycle back to first bead
    };

    const countPreviousBeadsInRow = col => {
        const valueToMatch = myArr[col];
        let result = 0;
        for (let i = 0; i < col; i++) {
            if (myArr[i] == valueToMatch) {
                result++;
            }
        }
        return result;
    };

    if (index == 1) {
        if (myArr[0] == 0) { // if first column is a down column
            exp.tubularStartingColumn = nextCol(0);
        } else { // if first column is an up column
            exp.tubularStartingColumn = nextCol(nextCol(0));
        }
    } else {
        exp.tubularStartingColumn = nextCol(exp.tubularStartingColumn);
    }

    let timesToCycle = countPreviousBeadsInRow(exp.tubularStartingColumn);

    let result = row;

    for (let i = 0; i < timesToCycle; i++) {
        result.push(result.shift());
    }

    return result;
};

exp.getWordChart = ({strip, options}) => {

    if (exp.shouldCombineRows()) return exp.getBrickWordChart(strip);

    if (settings.pattern.getWordChartKey) {
        return exp[settings.pattern.getWordChartKey](strip);
    }

    let result = {text: []};
    let myRow, reverse, myArrow;
    exp.hasBlanks = false;

    let myStrip = (settings.pattern.rotateCamera) ? exp.getPeyoteStrip(strip) : strip;

    const tubularStep = ( // should we step up rows for tubular mode?
        settings.pattern.rotateCamera &&
        options.tubular &&
        (beads.rowOffset[0] !== beads.rowOffset[beads.rowOffset.length - 1])
    );

    exp.tubularStartingColumn = 0;

    myStrip.rows.forEach((row, i) => {
        let rowNumber = i + 1;
        if (settings.pattern.rotateCamera) rowNumber++;
        if (settings.pattern.rotateCamera && // special case: peyote rows 1 and 2
            (rowNumber == 2)) {
            result.text.push(lang.caps(lang.get('rows 1 and 2')) + ': ');
        } else {
            result.text.push(lang.caps(lang.get('row')) + ' ' + + rowNumber.toString() + ': ');
        }
        if (options.shouldCommute && settings.pattern.canSelectCommute) {
            reverse = (i % 2) ? true : false; // does row go right <- left?
            myArrow = reverse ? '← ' : '→ ';
            result.text.push(myArrow);
            myRow = exp.parseRow(row, reverse);
        } else {
            if (tubularStep) {
                row = exp.cycleRow({row, index: i, options});
            }
            myRow = exp.parseRow(row);
        }
        myRow.push('\n');

        myRow.forEach(element => {
            result.text.push(element);
        });
    });

    if (exp.hasBlanks) result.text.push({
        text: '\n* = '+ lang.get('space between beads explanation on pdf export', 'space between beads')
    });

    return result;
};

exp.getWordChartsOnly = ({options, fromEditorTab=false}) => {
    if (!fromEditorTab && options?.useCustomWordChart) {
        return exp.getCustomWordChart();
    }
    if (settings.pattern.specialWordChartKey) {
        return exp[settings.pattern.specialWordChartKey]();
    }
    if (settings.pattern.simpleExport) return null;

    let result = [];

    let strips = exp.getStrips({options}); // returns an array of strips. each strip contains an array of beads and extra info
    let header;

    strips.forEach(strip => {
        header = lang.get('word chart', 'Word Chart');

        const panelName = (settings.pattern.name === 'star') ?
            lang.get('referring to a warped square in pdf export', 'for warped square'):
            lang.get('referring to a panel in pdf export', 'for panel');

        if (strips.length > 1) header += ' ' + panelName + ' ' + strip.stripNumber.toString();
        result.push(exp.getTextContent(header, 'header'));
        let myWordChart = exp.getWordChart({strip, options});
        result.push(exp.getTextContent(myWordChart, 'wordChart'));
    });

    return result;
};
